// English strings for the kit. The source of truth for `TranslationKey`.
// Interpolation uses i18next syntax (`{{name}}`) so the app can register this object as-is.
export const en = {
  ui: {
    calendar: {
      previousMonth: "Previous month",
      nextMonth: "Next month",
    },
    card: {
      moreInfo: "More information",
    },
    comboBox: {
      noResults: "No results",
      clearSelection: "Clear selection",
    },
    confirmDialog: {
      cancel: "Cancel",
    },
    copyButton: {
      copy: "Copy",
      copied: "Copied",
    },
    datePicker: {
      openCalendar: "Open calendar",
      closeCalendar: "Close calendar",
    },
    dialog: {
      closeLabel: "Close",
    },
    fileUploader: {
      chooseFile: "Choose file",
      chooseFiles: "Choose files",
      dragAndDrop: "or drag and drop",
      download: "Download file",
      remove: "Remove file",
    },
    formField: {
      optional: "Optional",
    },
    input: {
      clearField: "Clear field",
      password: "Password",
      showPassword: "Show password",
    },
    menu: {
      submenuAriaLabel: "{{text}} submenu",
    },
    pagination: {
      show: "Show",
      pagination: "Pagination",
      goToPrevPage: "Go to previous page",
      goToNextPage: "Go to next page",
      goToPage: "Go to page {{pageNumber}}",
      itemsPerPage: "Items per page",
      itemsRange: "{{from}}-{{to}} of {{total}}",
    },
    segment: {
      segmentControl: "Segment control",
    },
    select: {
      clearSelection: "Clear selection",
      noResults: "No results",
    },
    table: {
      selectionSummary: "Selected {{count}} of {{total}} rows",
      selectionSummaryAll: "Selected all {{total}} rows",
      selectAllButton: "Select all {{total}} rows",
      selectAllItemsOnPageAriaLabel: "Select all items on current page",
      selectRowAriaLabel: "Select row",
      dataTableAriaLabel: "Data table",
      paginationAriaLabel: "{{table}} pagination",
    },
    tabs: {
      moreTabs: "More tabs",
    },
    tag: {
      remove: "Remove",
    },
    toast: {
      closeNotification: "Close notification",
    },
  },
} as const;

export type Translations = typeof en;
